import React from 'react';

export default function FeedbackNotification({ show, onClose, onGiveFeedback }) {
  if (!show) return null;
  return (
    <div className="feedback-notification-overlay">
      <div className="feedback-notification">
        <button className="feedback-close-btn" onClick={onClose} aria-label="Close feedback notification">✕</button>
        <div className="feedback-icon">✨</div>
        <h3 className="feedback-title">Enjoying Your Cosmic Journey?</h3>
        <p className="feedback-description">Your insights help us guide you better. Share your experience!</p>
        <div className="feedback-actions">
          <button className="feedback-btn feedback-btn-primary" onClick={onGiveFeedback}>Give Feedback</button>
          <button className="feedback-btn feedback-btn-secondary" onClick={onClose}>Maybe Later</button>
        </div>
        <div className="feedback-footer">Takes less than a minute ⏱️</div>
      </div>
    </div>
  );
}